import * as ko from "knockout";

interface IParams {
    referenceObject: any
    referenceKey: string
}

export abstract class AbstractManager {

    private data: KnockoutObservableArray<string> = ko.observableArray<string>([]);

    constructor(params: IParams) {
        params.referenceObject[params.referenceKey] = this;
    }

    add(id: string) {
        this.data.push(id);
    }

    remove(id: string): void {
        this.data.remove(id);
    }

}
